<template>
  <div class="examineMain">
    <div class="captionContainer">
      <p class="caption" :class="isOdd ? 'blueFont' : 'yellowFont'">{{caption}}</p>
    </div>

    <el-form label-width="180px" style="margin: 40px 0;">
      <el-form-item label="项目概况:">
        <el-input
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 8}"
          v-model="backOverview"
          style="width: 85%"
          disabled
          placeholder="暂无"
        ></el-input>
      </el-form-item>
      <div v-if="backOverviewPic && backOverviewPic.length" style="margin-top: -15px;">
        <p
          style="height:30px;margin-left: 180px;line-height: 20px;font-size: 14px;"
          class="color606266"
        >
          <i class="el-icon-upload"></i>相关图片：
        </p>
        <div class="picDivBox">
          <div class="picDiv" v-for="(file, index) in backOverviewPic" :key="index + file.address">
            <img :src="downloadUrl + file.address" class="width100" />
          </div>
        </div>
      </div>

      <el-form-item label="社会效益和经济效益:" style="margin-top: 30px;">
        <el-input
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 8}"
          v-model="backBenefit"
          style="width: 85%"
          disabled
          placeholder="暂无"
        ></el-input>
      </el-form-item>
      <div v-if="backBenefitPic && backBenefitPic.length" style="margin-top: -15px;">
        <p
          style="height:30px;margin-left: 180px;line-height: 20px;font-size: 14px;"
          class="color606266"
        >
          <i class="el-icon-upload"></i>相关图片：
        </p>
        <div class="picDivBox">
          <div class="picDiv" v-for="(file, index) in backBenefitPic" :key="index + file.address">
            <img :src="downloadUrl + file.address" class="width100" />
          </div>
        </div>
      </div>

      <el-form-item label="可操作性和示范性:" style="margin-top: 30px;">
        <el-input
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 8}"
          v-model="backOperability"
          style="width: 85%"
          disabled
          placeholder="暂无"
        ></el-input>
      </el-form-item>
      <div v-if="backOperabilityPic && backOperabilityPic.length" style="margin-top: -15px;">
        <p
          style="height:30px;margin-left: 180px;line-height: 20px;font-size: 14px;"
          class="color606266"
        >
          <i class="el-icon-upload"></i>相关图片：
        </p>
        <div class="picDivBox">
          <div
            class="picDiv"
            v-for="(file, index) in backOperabilityPic"
            :key="index + file.address"
          >
            <img :src="downloadUrl + file.address" class="width100" />
          </div>
        </div>
      </div>
    </el-form>

    <!-- 技术采用情况介绍 -->
    <div v-if="backDeclareLevel && backDeclareLevel.length">
      <div class="captionBox">
        <p class="caption" style="color: #00b0f0;">技术采用情况介绍</p>
      </div>
      <div class="commonItem" v-for="(item, index) in backDeclareLevel" :key="index">
        <p class="title" style="color: #00b0f0;">{{item.level_name}}</p>
        <p class="description">技术情况说明：</p>
        <div class="textArea">
          <el-input v-model="item.technology_introduce" type="textarea" :autosize="{ minRows: 5, maxRows: 8}" disabled></el-input>
        </div>
      </div>
    </div>

    <!-- 创新项采用情况介绍 -->
    <div v-if="backInnovateTechnology && backInnovateTechnology.length">
      <div class="captionBox">
        <p class="caption" style="color: #ff8f14;">创新项采用情况介绍</p>
      </div>
      <div class="commonItem" v-for="(item, index) in backInnovateTechnology" :key="index">
        <p class="title" style="color: #ff8f14;">{{item.it_name}}</p>
        <p class="description">技术情况说明：</p>
        <div class="textArea">
          <el-input v-model="item.introduce" type="textarea" :autosize="{ minRows: 5, maxRows: 8}" disabled></el-input>
        </div>
        <p class="description">自评分：{{item.score}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import config from '../config'

const { downloadUrl } = config
export default {
  props: [
    'backDeclareLevel',
    'backInnovateTechnology',
    'backOverview',
    'backBenefit',
    'backOperability',
    'isOdd',
    'caption',
    'backOverviewPic',
    'backBenefitPic',
    'backOperabilityPic'
  ],
  data () {
    return {
      downloadUrl
    }
  }
}
</script>

<style lang="scss">
.examineMain {
  .el-form-item__label {
    font-size: 15px;
  }
  .captionContainer {
    display: flex;
    align-items: center;
    background: #f8f8f8;
    height: 50px;
    width: 98%;
    margin: 40px 0 20px 0;
    .caption {
      margin-left: 80px;
      font-size: 20px;
    }
    .yellowFont {
      color: #ff8f14;
    }
    .blueFont {
      color: #00b0f0;
    }
  }
  .picDivBox {
    margin-left: 180px;
    display: flex;
    height: 100px;
    white-space: nowrap;
    .picDiv {
      position: relative;
      width: 100px;
      height: 100px;
      margin-right: 5px;
      .width100 {
        width: 100px;
        height: 100px;
      }
    }
  }
}
</style>
